export default function GS_HOME() {
  return (
    <div className="p-4">
      <h1>GS HOME</h1>
      <h1>GS HOME</h1>
    </div>
  );
}
